__turbopack_context__.v({
  "chip": "qD4-9G_chip",
  "content": "qD4-9G_content",
  "footer": "qD4-9G_footer",
  "gradient": "qD4-9G_gradient",
  "header": "qD4-9G_header",
  "inView": "qD4-9G_inView",
});
